import { Icons } from '@contiple/antd-ds';
import React from 'react';

const DynamicIcon = ({ name }: { name?: string }) => {
  if (!name) return null;
  const Comp = Icons[name as keyof typeof Icons] as React.ElementType<object>;
  return Comp ? <Comp size={24} /> : null;
};
export default DynamicIcon;
